import { render, staticRenderFns } from "./PracticalExamStudentsSelect.vue?vue&type=template&id=4fc66ace&"
import script from "./PracticalExamStudentsSelect.vue?vue&type=script&lang=ts&"
export * from "./PracticalExamStudentsSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports